import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import AnimePlayerModal from 'components/AnimePlayerModal/AnimePlayerModal'
import Loader from 'components/Loader/Loader'
import { getAnime, getAnimeEpisodes } from 'service/AnimeService'

const AnimePlayerPage = () => {
  const { mediaId } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  const [anime, setAnime] = useState(location.state?.anime || null)
  const [episodes, setEpisodes] = useState(Array.isArray(location.state?.episodes) ? location.state.episodes : [])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    const loadPlayerData = async () => {
      try {
        setLoading(true)
        setError('')

        let nextAnime = anime
        if (!nextAnime) {
          const animeResponse = await getAnime(mediaId)
          nextAnime = animeResponse.data || null
        }

        let nextEpisodes = episodes
        const episodesResponse = await getAnimeEpisodes(mediaId)
        const episodesData = episodesResponse?.data?.results || episodesResponse?.data || []
        if (Array.isArray(episodesData)) {
          nextEpisodes = episodesData
        }

        setAnime(nextAnime)
        setEpisodes(Array.isArray(nextEpisodes) ? nextEpisodes : [])
      } catch (loadError) {
        console.error('Error loading anime player page:', loadError)
        setError('Не удалось загрузить аниме-плеер')
      } finally {
        setLoading(false)
      }
    }

    loadPlayerData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mediaId])

  const initialEpisode = useMemo(() => {
    const requestedEpisode = new URLSearchParams(location.search).get('episode')
    if (!requestedEpisode || episodes.length === 0) {
      return episodes[0] || null
    }

    return (
      episodes.find((episode) => String(episode.id) === requestedEpisode)
      || episodes.find((episode) => String(episode.episode_number) === requestedEpisode)
      || episodes[0]
      || null
    )
  }, [episodes, location.search])

  if (loading) {
    return (
      <div style={{ minHeight: '50vh', display: 'grid', placeItems: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <Loader size="large" />
          <p>Загрузка плеера...</p>
        </div>
      </div>
    )
  }

  if (error || !anime) {
    return (
      <div style={{ minHeight: '50vh', display: 'grid', placeItems: 'center', textAlign: 'center' }}>
        <div>
          <h2>{error || 'Аниме не найдено'}</h2>
          <button type="button" onClick={() => navigate(-1)}>
            Назад
          </button>
        </div>
      </div>
    )
  }

  return (
    <AnimePlayerModal
      anime={anime}
      episodes={episodes}
      initialEpisode={initialEpisode}
      onClose={() => navigate(-1)}
      onEpisodeChange={() => {}}
      asPage
    />
  )
}

export default AnimePlayerPage
